// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-button_9694e7e6 {
  display: flex;
  align-items: center;
  line-height: 1.5;
  position: relative;
  padding: 0.334rem;
  margin: -0.334rem;
  overflow: hidden;
}
.checkbox-button__box_9694e7e6 {
  position: relative;
  display: flex;
  align-items: center;
  vertical-align: top;
  max-width: 100%;
}
.checkbox-button_disabled_9694e7e6 {
  cursor: default;
}
.checkbox-button__caption_9694e7e6 {
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;
  min-width: 0;
}
.checkbox-button__icon_9694e7e6 {
  margin-right: 0.667rem;
}
.checkbox-button__label_highlighted_9694e7e6 {
  color: #26649e;
}
.checkbox-button__pointer_9694e7e6 {
  position: relative;
  transform: translateZ(0);
  width: 1.167rem;
  min-width: 1.167rem;
  height: 1.167rem;
  margin-right: 0.667rem;
  border-radius: 0.167em;
  pointer-events: none;
  background-color: #fff;
}
.checkbox-button__pointer_svg_9694e7e6 {
  width: 1.167rem;
  min-width: 1.167rem;
  height: 1.167rem;
}
.checkbox-button__pointer_r1_9694e7e6 {
  fill: #84919b;
}
.checkbox-button__pointer_r2_9694e7e6 {
  fill: #c4edeb;
}
.checkbox-button__pointer_checked_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__pointer_nested-b_9694e7e6 {
  fill: #84919b;
}
.checkbox-button__pointer_nested-p_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__pointer_plus_9694e7e6 {
  fill: #657682;
}
.checkbox-button__pointer_minus_9694e7e6 {
  fill: #657682;
}
.checkbox-button__pointer_only_9694e7e6 {
  margin-right: 0;
}
.checkbox-button__handler_9694e7e6 {
  position: absolute;
  display: block;
  width: 14px;
  height: 14px;
  opacity: 0;
  cursor: pointer;
  z-index: 10;
}
.checkbox-button__handler_9694e7e6:not(:disabled):hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6,
.checkbox-button__handler_9694e7e6:not(:disabled) ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_9694e7e6 {
  box-shadow: 0 0 0 2px #c4edeb;
}
.checkbox-button__handler_9694e7e6:not(:disabled):hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_r1_9694e7e6,
.checkbox-button__handler_9694e7e6:not(:disabled) ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_r1_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__handler_9694e7e6:not(:disabled):hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_nested_9694e7e6,
.checkbox-button__handler_9694e7e6:not(:disabled) ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_nested_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__handler_9694e7e6:not(:disabled):focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6 {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.checkbox-button__handler_9694e7e6:not(:disabled):focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_r1_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__handler_9694e7e6:not(:disabled):focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_nested_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__handler_pressed_9694e7e6:hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6,
.checkbox-button__handler_pressed_9694e7e6 ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_9694e7e6 {
  box-shadow: 0 0 0 2px #c4edeb, inset 0 0 0 2px #c4edeb;
}
.checkbox-button__handler_pressed_9694e7e6:focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6 {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.checkbox-button__handler_9694e7e6:checked:not(:disabled):hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6,
.checkbox-button__handler_9694e7e6:checked:not(:disabled) ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_9694e7e6 {
  box-shadow: 0 0 0 2px #c4edeb;
}
.checkbox-button__handler_9694e7e6:checked:not(:disabled):focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6 {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.checkbox-button__handler_pressed_9694e7e6:checked:hover ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_checked_9694e7e6,
.checkbox-button__handler_pressed_9694e7e6:checked:focus-visible ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_checked_9694e7e6,
.checkbox-button__handler_pressed_9694e7e6:checked ~ .checkbox-button__caption_9694e7e6:hover .checkbox-button__pointer_checked_9694e7e6 {
  fill: #1d5080;
}
.checkbox-button__handler_9694e7e6:disabled ~ .checkbox-button__caption_9694e7e6,
.checkbox-button__handler_disabled_9694e7e6 ~ .checkbox-button__caption_9694e7e6 {
  color: #c1c8cd;
  cursor: default;
}
.checkbox-button__handler_9694e7e6:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6,
.checkbox-button__handler_disabled_9694e7e6 ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6 {
  background-color: #eaedef;
}
.checkbox-button__handler_9694e7e6:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_r1_9694e7e6,
.checkbox-button__handler_disabled_9694e7e6 ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_r1_9694e7e6 {
  fill: #c1c8cd;
}
.checkbox-button__handler_9694e7e6:checked:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_9694e7e6 {
  background-color: #fff;
}
.checkbox-button__handler_9694e7e6:checked:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_r1_9694e7e6 {
  fill: #c1c8cd;
}
.checkbox-button__handler_9694e7e6:checked:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_checked_9694e7e6 {
  fill: #c1c8cd;
}
.checkbox-button__handler_9694e7e6:indeterminate:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_nested-b_9694e7e6 {
  fill: #c1c8cd;
}
.checkbox-button__handler_9694e7e6:indeterminate:disabled ~ .checkbox-button__caption_9694e7e6 .checkbox-button__pointer_nested-p_9694e7e6 {
  fill: #c1c8cd;
}
.checkbox-button_click-through_9694e7e6 {
  pointer-events: none;
}
.checkbox-button_main_9694e7e6 {
  font-weight: 600;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-button": `checkbox-button_9694e7e6`,
	"checkbox-button__box": `checkbox-button__box_9694e7e6`,
	"checkbox-button_disabled": `checkbox-button_disabled_9694e7e6`,
	"checkbox-button__caption": `checkbox-button__caption_9694e7e6`,
	"checkbox-button__icon": `checkbox-button__icon_9694e7e6`,
	"checkbox-button__label_highlighted": `checkbox-button__label_highlighted_9694e7e6`,
	"checkbox-button__pointer": `checkbox-button__pointer_9694e7e6`,
	"checkbox-button__pointer_svg": `checkbox-button__pointer_svg_9694e7e6`,
	"checkbox-button__pointer_r1": `checkbox-button__pointer_r1_9694e7e6`,
	"checkbox-button__pointer_r2": `checkbox-button__pointer_r2_9694e7e6`,
	"checkbox-button__pointer_checked": `checkbox-button__pointer_checked_9694e7e6`,
	"checkbox-button__pointer_nested-b": `checkbox-button__pointer_nested-b_9694e7e6`,
	"checkbox-button__pointer_nested-p": `checkbox-button__pointer_nested-p_9694e7e6`,
	"checkbox-button__pointer_plus": `checkbox-button__pointer_plus_9694e7e6`,
	"checkbox-button__pointer_minus": `checkbox-button__pointer_minus_9694e7e6`,
	"checkbox-button__pointer_only": `checkbox-button__pointer_only_9694e7e6`,
	"checkbox-button__handler": `checkbox-button__handler_9694e7e6`,
	"checkbox-button__pointer_nested": `checkbox-button__pointer_nested_9694e7e6`,
	"checkbox-button__handler_pressed": `checkbox-button__handler_pressed_9694e7e6`,
	"checkbox-button__handler_disabled": `checkbox-button__handler_disabled_9694e7e6`,
	"checkbox-button_click-through": `checkbox-button_click-through_9694e7e6`,
	"checkbox-button_main": `checkbox-button_main_9694e7e6`
};
export default ___CSS_LOADER_EXPORT___;
